/* eslint-disable no-plusplus */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable arrow-body-style */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-vars */
import React from 'react';
import { useFormik } from 'formik';

import {
  AlertAdapter,
  CommonCurrencyInput,
  CommonDropdown,
  CommonInput,
  DatePicker,
  OutlinedButton,
  RegularButton,
} from 'pg-ui-library';
import {
  CoverageTypeEnum,
  IBenefitCoverageFixedMaximum,
  IBenefitCoverageRuleMaximum,
  IBenefitType,
  IGiConfig,
} from 'src/interfaces';
import { useTranslation } from 'react-i18next';
import { PriceFormType } from 'src/services/benefits.service';
import { useNavigate } from 'react-router-dom';
import {
  AccordeonContent,
  FixedPriceContent,
  FixedPriceHeader,
  FixedPriceLine,
  HeaderContent,
  HeaderInfo,
  HorizontalLine,
} from './styles';

import { usePatchBenefitAgePrice } from '../../mutations/patch-benefit-age-price.mutation';
import { usePostBenefitAgePrice } from '../../mutations/post-benefit-age-price.mutation';
import { usePatchBenefitFixedPrice } from '../../mutations/patch-benefit-fixed-price.mutation';
import { usePostBenefitFixedPrice } from '../../mutations/post-benefit-fixed-price.mutation';
import { useBenefitDeletePrice } from '../../queries/benefit-delete-price.mutation';
import { BenefitPriceCoverageForm } from '../benefit-price-coverage-form';

const isOverlapping = (range1: IGiConfig, range2: IGiConfig): boolean => {
  const start1 = Number(range1.ageStart);
  const end1 = Number(range1.ageEnd);
  const start2 = Number(range2.ageStart);
  const end2 = Number(range2.ageEnd);

  return !(end1 < start2 || start1 > end2);
};

const hasOverlappingRanges = (array: IGiConfig[]): boolean => {
  for (let i = 0; i < array.length - 1; i++) {
    for (let j = i + 1; j < array.length; j++) {
      if (isOverlapping(array[i], array[j])) {
        return true;
      }
    }
  }
  return false;
};

export const BenefitFixedPriceForm: React.FC<{
  initialValue: PriceFormType;
  selectedBenefitType: IBenefitType | undefined;
}> = ({ initialValue, selectedBenefitType }) => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const dropdownOptions = selectedBenefitType?.typeBenefit
    .filter(v => v.costCalculationMethod !== 'Limited')
    .map(b => ({
      key: b.benefitId,
      label: b.benefitId,
      value: b.benefitId,
    }));

  const patchFixedPriceMutation = usePatchBenefitFixedPrice();
  const postFixedMutation = usePostBenefitFixedPrice();

  const removePriceMutation = useBenefitDeletePrice();

  const isLoading = patchFixedPriceMutation.isLoading || postFixedMutation.isLoading || removePriceMutation.isLoading;

  const getBenefitCostCalculation = (benefitId: string) => {
    return (
      selectedBenefitType?.typeBenefit.filter(b => b.benefitId === benefitId).map(b => b.costCalculationMethod)[0] ||
      'Fixed'
    );
  };

  const submitFixedBenefit = (values: PriceFormType) => {
    if (values.id) {
      return patchFixedPriceMutation.mutateAsync(values);
    }
    return postFixedMutation.mutateAsync(values);
  };

  const formik = useFormik<PriceFormType>({
    initialValues: {
      id: initialValue.id || undefined,
      versionId: initialValue.versionId || selectedBenefitType?.versionId || '',
      benefitId: initialValue.benefitId || selectedBenefitType?.typeBenefit[0].benefitId || '',

      smoke: initialValue.smoke || false,
      type: initialValue.type || 'fixed',
      agePriceLines: initialValue.agePriceLines || [],
      fixedPriceLines: initialValue.fixedPriceLines || [],
      coverage: initialValue.coverage,
    },
    onSubmit: async values => {
      try {
        await submitFixedBenefit({ ...values, type: 'fixed' });
      } catch (error) {
        // do not redirect
      }
    },
    enableReinitialize: true,
  });

  const addFixedPriceLine = () => {
    const newLine = {
      benefitId: formik.values.benefitId,
      deduction: 0,
      contribution: 0,
    };
    if (formik.values.fixedPriceLines.length >= 1) {
      return;
    }
    formik.setFieldValue('fixedPriceLines', [...formik.values.fixedPriceLines, newLine]);
  };

  const deletePrice = async () => {
    try {
      await removePriceMutation.mutateAsync({
        id: formik.values.id as string,
        type: getBenefitCostCalculation(formik.values.benefitId),
      });
    } catch (error) {
      // do not redirect
    }
  };

  return (
    <AccordeonContent>
      <HeaderInfo>
        <div>
          <RegularButton onClick={() => formik.handleSubmit()} disabled={isLoading} type="submit">
            {formik.values.id ? t('global.form.update') : t('global.form.save')}
          </RegularButton>
          {formik.values.id && (
            <OutlinedButton onClick={deletePrice} disabled={isLoading}>
              {t('global.form.delete')}
            </OutlinedButton>
          )}
        </div>
      </HeaderInfo>
      <HeaderContent>
        <CommonDropdown
          disabled={!!formik.values.id}
          label="Benefit Id"
          id="benefitId"
          name="benefitId"
          setValue={(value: string) => {
            formik.setFieldValue('benefitId', value);
          }}
          value={formik.values.benefitId}
          options={dropdownOptions || []}
          wrapperStyle={{ width: '10%' }}
          selectStyle={{
            maxWidth: 'none',
            width: '100%',
            backgroundColor: '#ffffff',
            height: '35px',
          }}
        />
        <div>
          <div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '15px',
              }}
            >
              <span>{t('benefits.edit.label.smoke')}</span>

              <div style={{ display: 'flex', gap: '15px', fontSize: '15px' }}>
                <div style={{ display: 'flex', textAlign: 'center', gap: '5px' }}>
                  <input
                    type="radio"
                    id="smoke1"
                    name="smoke"
                    value="true"
                    checked={formik.values.smoke}
                    onChange={val => {
                      formik.setFieldValue('smoke', true);
                    }}
                  />
                  <label>{t('global.form.yes')}</label>
                </div>

                <div style={{ display: 'flex', textAlign: 'center', gap: '5px' }}>
                  <input
                    type="radio"
                    id="smoke2"
                    name="smoke"
                    value="false"
                    checked={!formik.values.smoke}
                    onChange={val => {
                      formik.setFieldValue('smoke', false);
                    }}
                  />
                  <label>{t('global.form.no')}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </HeaderContent>

      <BenefitPriceCoverageForm
        value={formik.values.coverage}
        onChange={coverage => formik.setFieldValue('coverage', coverage)}
      />

      <FixedPriceHeader>
        <p>{t('benefits.edit.fixedPrice.fixedPriceLine')}</p>
        <HorizontalLine />
        <RegularButton onClick={() => addFixedPriceLine()} disabled={formik.values.fixedPriceLines.length >= 1}>
          {t('global.form.add')}
        </RegularButton>
      </FixedPriceHeader>
      <FixedPriceContent>
        {formik.values.fixedPriceLines.map((val, index) => (
          <FixedPriceLine key={index}>
            <CommonCurrencyInput
              id="rateDeduction"
              label={index === 0 ? 'Rate/Deduction' : ''}
              name="rateDeduction"
              placeholder="Please enter a number"
              prefix="$"
              decimalsLimit={7}
              allowNegativeValue={false}
              value={val.deduction}
              groupSeparator=","
              decimalSeparator="."
              onValueChange={v => {
                if (Number.isNaN(v)) {
                  formik.setFieldValue(`fixedPriceLines[${index}].deduction`, 0);
                } else {
                  formik.setFieldValue(`fixedPriceLines[${index}].deduction`, v);
                }
              }}
            />
            <CommonCurrencyInput
              id="rateContribution"
              label={index === 0 ? 'Rate/Contribution' : ''}
              name="rateContribution"
              placeholder="Please enter a number"
              prefix="$"
              decimalsLimit={7}
              allowNegativeValue={false}
              groupSeparator=","
              decimalSeparator="."
              value={val.contribution}
              onValueChange={v => {
                if (Number.isNaN(v)) {
                  formik.setFieldValue(`fixedPriceLines[${index}].contribution`, 0);
                } else {
                  formik.setFieldValue(`fixedPriceLines[${index}].contribution`, v);
                }
              }}
            />
          </FixedPriceLine>
        ))}
      </FixedPriceContent>
    </AccordeonContent>
  );
};

export const BenefitAgePriceForm: React.FC<{
  initialValue: PriceFormType;
  selectedBenefitType: IBenefitType | undefined;
}> = ({ initialValue, selectedBenefitType }) => {
  const { t } = useTranslation();

  const dropdownOptions = selectedBenefitType?.typeBenefit
    .filter(v => v.costCalculationMethod !== 'Limited')
    .map(b => ({
      key: b.benefitId,
      label: b.benefitId,
      value: b.benefitId,
    }));

  const navigate = useNavigate();

  const patchAgePriceMutation = usePatchBenefitAgePrice();
  const postAgeMutation = usePostBenefitAgePrice();

  const removePriceMutation = useBenefitDeletePrice();

  const isLoading = patchAgePriceMutation.isLoading || postAgeMutation.isLoading || removePriceMutation.isLoading;

  const getBenefitCostCalculation = (benefitId: string) => {
    return (
      selectedBenefitType?.typeBenefit.filter(b => b.benefitId === benefitId).map(b => b.costCalculationMethod)[0] ||
      'Fixed'
    );
  };

  const submitTableBenefit = (values: PriceFormType) => {
    if (values.id) {
      return patchAgePriceMutation.mutateAsync(values);
    }
    return postAgeMutation.mutateAsync(values);
  };

  const formik = useFormik<PriceFormType>({
    initialValues: {
      id: initialValue.id || undefined,
      versionId: initialValue.versionId || selectedBenefitType?.versionId || '',
      benefitId: initialValue.benefitId || selectedBenefitType?.typeBenefit[0].benefitId || '',
      smoke: initialValue.smoke || false,
      type: initialValue.type || 'Table',
      coverage: initialValue.coverage,
      agePriceLines: initialValue.agePriceLines || [],
      fixedPriceLines: initialValue.fixedPriceLines || [],
    },
    onSubmit: async values => {
      if (values.coverage.coverageType === CoverageTypeEnum.ELECTED_COVERAGE_AMOUNT_WITH_FIXED_MAXIMUM) {
        if (hasOverlappingRanges((values.coverage.options as IBenefitCoverageFixedMaximum).giConfig)) {
          AlertAdapter(t('benefits.premiumConfig.invalidGIAgeRange'), 'warning');
          return;
        }
      }

      if (values.coverage.coverageType === CoverageTypeEnum.ELECTED_COVERAGE_AMOUNT_WITH_RULE_BASED_MAXIMUM) {
        if (hasOverlappingRanges((values.coverage.options as IBenefitCoverageRuleMaximum).giConfig)) {
          AlertAdapter(t('benefits.premiumConfig.invalidGIAgeRange'), 'warning');
          return;
        }
      }

      try {
        await submitTableBenefit({ ...values, type: 'Table' });
      } catch (error) {
        // do not redirect
      }
    },
    enableReinitialize: true,
  });

  const deletePrice = async () => {
    try {
      await removePriceMutation.mutateAsync({
        id: formik.values.id as string,
        type: getBenefitCostCalculation(formik.values.benefitId),
      });
      navigate(-1 as any);
    } catch (error) {
      // do not redirect
    }
  };

  return (
    <AccordeonContent>
      <HeaderInfo>
        <div>
          <RegularButton onClick={() => formik.handleSubmit()} disabled={isLoading} type="submit">
            {formik.values.id ? t('global.form.update') : t('global.form.save')}
          </RegularButton>
          {formik.values.id && (
            <OutlinedButton onClick={deletePrice} disabled={isLoading}>
              {t('global.form.delete')}
            </OutlinedButton>
          )}
        </div>
      </HeaderInfo>
      <HeaderContent>
        <CommonDropdown
          disabled={!!formik.values.id}
          label="Benefit Id"
          id="benefitId"
          name="benefitId"
          setValue={(value: string) => {
            formik.setFieldValue('benefitId', value);
          }}
          value={formik.values.benefitId}
          options={dropdownOptions || []}
          wrapperStyle={{ width: '10%' }}
          selectStyle={{
            maxWidth: 'none',
            width: '100%',
            backgroundColor: '#ffffff',
            height: '35px',
          }}
        />

        <div>
          <div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '15px',
              }}
            >
              <span>{t('benefits.edit.label.smoke')}</span>

              <div style={{ display: 'flex', gap: '15px', fontSize: '15px' }}>
                <div style={{ display: 'flex', textAlign: 'center', gap: '5px' }}>
                  <input
                    type="radio"
                    id="smoke1"
                    name="smoke"
                    value="true"
                    checked={formik.values.smoke}
                    onChange={val => {
                      formik.setFieldValue('smoke', true);
                    }}
                  />
                  <label>{t('global.form.yes')}</label>
                </div>

                <div style={{ display: 'flex', textAlign: 'center', gap: '5px' }}>
                  <input
                    type="radio"
                    id="smoke2"
                    name="smoke"
                    value="false"
                    checked={!formik.values.smoke}
                    onChange={val => {
                      formik.setFieldValue('smoke', false);
                    }}
                  />
                  <label>{t('global.form.no')}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </HeaderContent>

      <BenefitPriceCoverageForm
        value={formik.values.coverage}
        onChange={cov => formik.setFieldValue('coverage', cov)}
      />
    </AccordeonContent>
  );
};
